export default function PHP_is_writable() {
  return (
    <div>
      <h1>PHP_is_writable</h1>
    </div>
  );
}
